import { htmlSerializer, linkResolver } from '@lib/data/prismic/helpers';
import { RichText, RichTextBlock } from 'prismic-reactjs';

const Text = ({
  slice,
}: {
  slice: {
    primary: { text: RichTextBlock[] | undefined };
  };
}) => (
  <div className="post-part single container">
    <RichText
      render={slice.primary.text}
      linkResolver={linkResolver}
      htmlSerializer={htmlSerializer}
    />
  </div>
);

export default Text;
